import styled from 'styled-components';
import { fontStyle, baseStyles, colorStyle } from '../commonStyles';

const HEADING_STYLES = {
  font: 'gtEesti',
  1: {
    size: 34,
    ls: 1,
    lh: 40,
  },
  2: {
    size: 28,
    ls: 1,
    lh: 32,
  },
  3: {
    size: 24,
    ls: '0.5',
    lh: 28,
  },
  4: {
    size: 22,
    ls: '0.3',
    lh: 26,
  },
  5: {
    size: 20,
    lh: 23,
  },
  6: {
    size: 18,
    lh: 21,
  },
};

export const HeadingStyledTag = styled.h1`
  ${baseStyles}
  u {
    color: ${(p) => p.theme.colors.primary};
    text-decoration: none;
  }

  ${fontStyle(HEADING_STYLES)}

  & > a {
    ${fontStyle(HEADING_STYLES)}
    ${colorStyle()}
  }
  & > a:hover,
  & > a:active,
  & > a:focus {
    ${fontStyle(HEADING_STYLES)}
    ${colorStyle()}
  }
`;
